var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('a',{staticClass:"file-download",attrs:{"href":_vm.url,"title":_vm.title,"target":"_blank"}},[_c('i',[_c(_vm.icon,{tag:"Component"})],1),_vm._v(" "),_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }